import { useQuery } from '@tanstack/react-query';
import type { ListNotificationsParams } from '@/modules/notifications/types';
import { notificationQueryOptions } from '@/modules/notifications/api/notifications.query';

/**
 * Polling feed query — drives both the bell badge and the dropdown/page list.
 *
 * `enabled` exists so surfaces without a tenant context can opt out: the feed is
 * tenant-scoped, and a signed-in super-admin has no tenant, so polling it from
 * the admin chrome would fire a pointless request every 45 seconds.
 */
export function useNotificationsQuery(
    params: ListNotificationsParams = {},
    options: { enabled?: boolean } = {},
) {
    return useQuery({
        ...notificationQueryOptions.list(params),
        enabled: options.enabled ?? true,
    });
}
